/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { CategoryPartList } from '../../CategoryPartList';
import { useCategoryResults } from '../../../api/getCategoryResults';
import { useProductDataTopNavMenuV2 } from '@/features/topNav/api/getProductDataTopNavMenuV2';
import { useLabels } from '@/hooks/useLabels';
import { useAcesFlags } from '@/features/ymme/utils/acesFlags';
import { usePageType } from '@/features/category/api/getPageType';

const labelMap = {
  lblShopByCategory: 'label_shop_by_category',
};

export const CMSShopByCategory = () => {
  const { acesEnabled, acesNonVehicleEndpointsEnabled } = useAcesFlags();
  const { data: pageTypeData } = usePageType();
  const { lblShopByCategory } = useLabels(labelMap);

  const hasCatalogPath = Boolean(pageTypeData?.categoryRepositoryIdPath);
  const hasMakeModelYearPath = Boolean(pageTypeData?.makeModelYearPath);

  const shouldUseV2MenuData =
    acesNonVehicleEndpointsEnabled && acesEnabled && pageTypeData?.pageType === 'CategoryGrouping';

  const { data: categoryDataV1 } = useCategoryResults({ enabled: !shouldUseV2MenuData });
  const { data: categoryDataV2 } = useProductDataTopNavMenuV2({
    level: -1,
    categoryIdPath: pageTypeData?.categoryRepositoryIdPath,
    isEnabled: shouldUseV2MenuData && (hasCatalogPath || hasMakeModelYearPath),
  });

  let categoryData;

  // Default to categoryDataV1
  categoryData = categoryDataV1;

  // Override if condition is met
  if (shouldUseV2MenuData) {
    categoryData = categoryDataV2;
  }

  const hasNoCategories = shouldUseV2MenuData
    ? !categoryData?.rootCategories?.[0]?.childCategories.length
    : !categoryData?.shopByCategory?.length;

  if (hasNoCategories) {
    return null;
  }

  return (
    <CategoryPartList
      data={{
        name: lblShopByCategory,
        shopByCategory: shouldUseV2MenuData
          ? categoryData?.rootCategories?.[0]?.shopByCategory
          : categoryData?.shopByCategory,
      }}
    />
  );
};
